import createDocumentResource from 'src/actions/shared/createDocumentResource';
import logout from 'src/actions/auth/logout';

interface AgentStatus {
  id: string;
  version: number;
  updatedAt: string;
  availabilityUpdatedAt: string;
  status: {
    availability: string;
    channels?: {
      MAIL: {
        available: boolean;
        changedAt: string;
      };
      MESSAGING: {
        available: boolean;
        changedAt: string;
      };
      TASK: {
        available: boolean;
        changedAt: string;
      };
      VOICE: {
        available: boolean;
        changedAt: string;
      };
    };
  };
}

const agentStatusResource = createDocumentResource<AgentStatus>({
  name: 'agentStatus',
  endpoint: 'v3/orgs/:orgId/agent-status/:agentId',
  observerCreator: ({ actions }) => {
    return ({ dispatch }) => {
      return {
        onBroadcast(item) {
          dispatch(actions.broadcast(item));
          handleAgentStatus(dispatch, item);
        },
      };
    };
  },
});

export function handleAgentStatus(dispatch, item) {
  if (item.status.availability === 'OFFLINE') {
    dispatch(logout());
  }
}
export default agentStatusResource;
